import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { message } from "antd";
import dayjs from "dayjs";
import { useQuery, useMutation, useQueryClient } from "react-query";
import eventDetailService from "../../../EventDetails/logic/useEventDetailsService";
import eventService from "../../components/EventList/logic/useEventListService";
import useEventList from "../../components/EventList/logic/useEventList";

const useEventEditModal = (idEvent, setIsModalEditOpen, includeUpcoming, isModalEditOpen) => {
  const {
    control,
    formState: { errors },
    reset,
    watch,
    handleSubmit,
    setValue,
  } = useForm();

  const queryClient = useQueryClient();

  useEffect(() => {
    if (isModalEditOpen) {
      queryClient.prefetchQuery(["eventDetailsData", idEvent], () =>
        eventDetailService.getEventDetailsData(idEvent)
      );
    }
  }, [idEvent, isModalEditOpen, queryClient]);

  const {
    data: dataEventDetails,
    isLoading: isLoadingEventDetails,
    error: errorEventDetails,
    refetch: refetchEventDetails,
  } = useQuery(["eventDetailsData", idEvent], () =>
    eventDetailService.getEventDetailsData(idEvent)
  , {
    enabled: isModalEditOpen,
  });

  const { refetch } = useEventList(includeUpcoming);
  let imgOrigin = `${process.env.REACT_APP_CORE_PATH}/images/events/${dataEventDetails?.data.image}`;
  useEffect(() => {
    if (dataEventDetails?.data) {
      const formattedDate = dayjs(dataEventDetails?.data?.date);
      const start_time = dayjs(dataEventDetails?.data?.start_time, "HH:mm");
      const end_time = dayjs(dataEventDetails?.data?.end_time, "HH:mm");
      setValue("title", dataEventDetails?.data?.title);
      setValue("location", dataEventDetails?.data?.location);
      setValue("description", dataEventDetails?.data?.description);
      setValue("longitude", dataEventDetails?.data?.longitude);
      setValue("latitude", dataEventDetails?.data?.latitude);
      setValue("placeQuery", dataEventDetails?.data?.placeQuery);
      setValue("date", formattedDate);
      setValue("range", [start_time, end_time]);
      setValue("file", imgOrigin);
    }
  }, [dataEventDetails?.data, imgOrigin, setValue]);

  const updateEventMutation = useMutation(
    (formData) => eventService.updateEvent(dataEventDetails.data.id, formData),
    {
      onSuccess: () => {
        refetchEventDetails();
        setIsModalEditOpen(false);
        refetch();
        reset();
        message.success("Event updated successfully");
      },
      onError: (error) => {
        console.error("Error updating event:", error);
        message.error("Failed to update event");
      },
    }
  );
  const onUpdateEvent = () => {
    const formattedTimes = watch("range")?.map((dateTimeString) => {
      const time = dayjs(dateTimeString).format("HH:mm");
      return time;
    });

    const imgElement = document.getElementById("imgError");
    const image = watch("file");
    if (image === undefined || image === null || image === "") {
      imgElement.innerHTML = "Please upload an image";
      return;
    } else {
      imgElement.innerHTML = "";
    }

    const formData = {
      start_time: formattedTimes[0],
      end_time: formattedTimes[1],
      location: watch("location"),
      isGuaranteed: watch("isGuaranteed"),
      title: watch("title"),
      description: watch("description"),
      date: new Date(watch("date")),
      placeQuery: watch("placeQuery"),
      longitude: watch("longitude"),
      latitude: watch("latitude"),
      file: watch("file"),
    };

    updateEventMutation.mutate(formData);
  };

  return {
    control,
    errors,
    reset,
    watch,
    handleSubmit,
    setValue,
    dataEvent: dataEventDetails?.data,
    isLoadingEventDetails,
    errorEventDetails,
    refetchEventDetails,
    onUpdateEvent,
  };
};

export default useEventEditModal;
